var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-dialog',{style:({ zIndex: _vm.options.zIndex }),attrs:{"persistent":"","width":_vm.options.width},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }